module.exports = __webpack_public_path__ + "img/redeem-title.ebc2405b.png";